import "./RealEstateCapital.module.css";
import GlobalHeader from "@/reusable_sections/Header";
import AssetClassSpotlight from "./sections/AssetClassSpotlight";
import FinancingSolutionsGrid from "./sections/FinancingSolutionsGrid";
import CapitalRequestGateway from "./sections/CapitalRequestGateway";
import InstitutionalFooter from "@/reusable_sections/Footer";
export default function RealEstateCapitalPage() {
  return <div>
      <GlobalHeader />
      <AssetClassSpotlight />
      <FinancingSolutionsGrid />
      <CapitalRequestGateway />
      <InstitutionalFooter />
    </div>;
}